module.exports = __webpack_public_path__ + "static/media/keyboard-press-short.6a7b358d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sounds/keyboard-press-short.mp3
// module id = 2126
// module chunks = 0